(function() {
  function initFormErrorHandler(forms) {
    forms.forEach(form => {
      let formSubmitBtn = form.querySelector(".button");
      let formSubmitInput = form.querySelector("#submit");

      formSubmitBtn.addEventListener("click", function() {
        let isFormValid = validateForm(form);

        if(isFormValid) {
          console.log("form is valid, submitting...");
          formSubmitInput.click();
        }
      });

      form.addEventListener("submit", function(event) {
        let isFormValid = validateForm(form);
        
        if(!isFormValid) {
          event.preventDefault();
        }
      });
    })
  }

  function validateForm(form) {
    const emailInputs = form.querySelectorAll('[type="email"]');
    const passwordInputs = form.querySelectorAll('[type="password"]');
    const textInputs = form.querySelectorAll('[type="text"]');
    const checkboxInputs = form.querySelectorAll('[type="checkbox"]');

    let hasErrors = false;

    emailInputs.forEach(emailInput => {
      console.log("emailInput", emailInput)
      let isEmail = emailInput.value.includes("@");
      let domain = emailInput.value.split(".");
      let isDomainValid = !domain[domain.length - 1].includes("@") && domain[domain.length - 1].length;

      if((!emailInput.value || !isEmail || !isDomainValid) && emailInput.required) {
        hasErrors = true;
        
        let errorMessage = 
          !emailInput.value ? "E-Mail fehlt" 
          : !isEmail || !isDomainValid ? "Die E-Mail-Adresse ist falsch. Versuche es nochmal" 
          : "";
        
        renderInputError(emailInput, errorMessage);
      }
    });

    passwordInputs.forEach(passwordInput => {
      console.log("passwordInput", passwordInput)
      if(!passwordInput.value && passwordInput.required) {
        hasErrors = true;
        let errorMessage = "Passwort fehlt";

        renderInputError(passwordInput, errorMessage);
      }
    });

    textInputs.forEach(textInput => {
      if(!textInput.value && textInput.required) {
        hasErrors = true;
        let errorMessage = "The field is required"

        renderInputError(textInput, errorMessage);
      }
    });

    checkboxInputs.forEach(checkboxInput => {
      if(!checkboxInput.checked) {
        let inputGroup = form.querySelectorAll(`input[name="${checkboxInput.name}"]`);
        let isInputGroupRequired = Array.from(inputGroup).find(input => input.required);
        let isInputGroupChecked = Array.from(inputGroup).find(input => input.checked);

        if(isInputGroupRequired && !isInputGroupChecked) {
          hasErrors = true;
          let errorMessage = "The field is required"

          renderInputError(checkboxInput, errorMessage);
        }
      }
    });

    return hasErrors ? false : true;
  }

  function renderInputError(input, errorMessage) {
    let inputParentContainer = input.closest("div");
    let errorEl = document.createElement("div");
    errorEl.classList.add("error-message");
    errorEl.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM11.1826 4.81836C10.7921 4.42784 10.1581 4.42784 9.76758 4.81836L8 6.58594L6.23242 4.81836C5.8419 4.42784 5.20791 4.42784 4.81738 4.81836C4.42718 5.20882 4.42718 5.84196 4.81738 6.23242L6.58496 8L4.81836 9.76758C4.42784 10.1581 4.42784 10.7921 4.81836 11.1826C5.20884 11.5728 5.84196 11.5729 6.23242 11.1826L8 9.41504L9.76758 11.1826C10.158 11.5729 10.7912 11.5728 11.1816 11.1826C11.5722 10.7921 11.5722 10.1581 11.1816 9.76758L9.41406 8L11.1826 6.23242C11.5728 5.84196 11.5728 5.20882 11.1826 4.81836Z" fill="#FFADB2"></path></svg><span class="body-01">' + errorMessage + '</span>';

    if(!inputParentContainer.classList.contains("error")) {
      inputParentContainer.classList.add("error");

      if(input.type !== "checkbox") { 
        inputParentContainer.after(errorEl);
      }
    
      input.addEventListener("input", () => {
        inputParentContainer.classList.remove("error");

        if(input.type !== "checkbox") {
          errorEl.remove();
        }
      }, { once: true });
    }
  }

  const forms = document.querySelectorAll(".form form");

  initFormErrorHandler(forms);
})();